module.exports = "../../static/fonts/WorkSans-SemiBold.7446058.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/WorkSans-SemiBold.ttf
// module id = 922
// module chunks = 2